/* PONGO homepage product finder (sections/pongo-finder.liquid), 2026-11.
   "Who's playing?" paddles: the picked paddle's top 3 shuffle into a row at the top, a ball flies to the best match,
   and a little ball character explains the pick. Also shows the waitlist thank-you after Shopify's reload. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFinder(pf) {
    if (!pf || pf._pongoFinder) return;
    pf._pongoFinder = true;
    var pfMsg = document.getElementById('pf-msg');
    var pfJump = document.getElementById('pf-jump');
    var pfBubble = pf.querySelector('.pf-bubble');
    var pfBuddy = pf.querySelector('.pf-buddy');
    var pfCards = Array.prototype.slice.call(pf.querySelectorAll('.pf-card'));
    var STAR = '<svg viewBox="0 0 100 100"><polygon points="50.0,2.0 56.8,11.6 66.4,4.9 69.5,16.2 80.9,13.2 79.9,24.9 91.6,26.0 86.6,36.7 97.3,41.7 89.0,50.0 97.3,58.3 86.6,63.3 91.6,74.0 79.9,75.1 80.9,86.8 69.5,83.8 66.4,95.1 56.8,88.4 50.0,98.0 43.2,88.4 33.6,95.1 30.5,83.8 19.1,86.8 20.1,75.1 8.4,74.0 13.4,63.3 2.7,58.3 11.0,50.0 2.7,41.7 13.4,36.7 8.4,26.0 20.1,24.9 19.1,13.2 30.5,16.2 33.6,4.9 43.2,11.6"/></svg><b>Your<br>match!</b>';
    pfCards.forEach(function (card) {
      var star = document.createElement('span');
      star.className = 'pf-match';
      star.setAttribute('aria-hidden', 'true');
      star.innerHTML = STAR;
      card.appendChild(star);
      var also = document.createElement('span');
      also.className = 'pf-also';
      also.setAttribute('aria-hidden', 'true');
      also.textContent = 'Good fit too';
      card.querySelector('.pf-pic').appendChild(also);
    });
    var pfSay = {
      all: "G'day! Three tables are ready to quote, two are back soon, plus Cornhole and event hire. Pick a paddle and I'll find your match.",
      home: "Backyard legend incoming! The Originals are the classic home table, and they're back soon. Want one that lives outside for good? Go the Permanent.",
      school: "Schools and councils mostly go the Permanent: tough, and it stays put. Want students or local artists to paint it? That's the Canvas.",
      business: "Put your brand on it! Kustoms starts with a Permanent and makes it all yours. The Pro does it on an Original, and it's back soon.",
      event: "Party time! Hire PONGO tables for the day, or bring Cornhole along. Want your own branded table for every event? That's Kustoms."
    };
    // Top 3 for each paddle, best first
    var pfRank = {
      all: [],
      home: ['pf-originals', 'pf-permanent', 'pf-cornhole'],
      school: ['pf-permanent', 'pf-canvas', 'pf-kustoms'],
      business: ['pf-kustoms', 'pf-permanent', 'pf-pro'],
      event: ['pf-hire', 'pf-cornhole', 'pf-kustoms']
    };
    var pfFor = { home: 'Picked for your backyard.', school: 'Picked for a school or council.', business: 'Picked for your business or brand.', event: 'Picked for an event.' };
    var pfJumpTo = { home: 'See the Originals', school: 'See the Permanent', business: 'See Kustoms', event: 'See event hire' };
    var pfCols = { all: [], home: ['originals', 'permanent'], school: ['permanent', 'canvas', 'kustoms'], business: ['kustoms', 'permanent', 'pro'], event: ['kustoms'] };
    var pfTop = document.getElementById('pf-top');
    var pfTopGrid = document.getElementById('pf-top-grid');
    var pfTopFor = document.getElementById('pf-top-for');
    var pfGroups = Array.prototype.slice.call(pf.querySelectorAll('.pf-group:not(.pf-top)'));
    pfCards.forEach(function (card, i) { card._home = card.parentNode; card._order = i; });
    var flying = null;

    function replay(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

    function fly(fromEl, toEl, onLand) {
      if (flying) { flying.remove(); flying = null; }
      if (reduce || !document.body.animate) { onLand(); return; }
      var a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect ? toEl.getBoundingClientRect() : toEl;
      var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2;
      var x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
      var lift = 90 + Math.min(220, Math.abs(x1 - x0) * .22 + Math.abs(y1 - y0) * .12);
      var frames = [];
      for (var i = 0; i <= 24; i++) {
        var t = i / 24;
        var x = x0 + (x1 - x0) * t;
        var y = y0 + (y1 - y0) * t - lift * 4 * t * (1 - t);
        frames.push({ transform: 'translate(' + x + 'px,' + y + 'px) scale(' + (1 + .5 * Math.sin(Math.PI * t)).toFixed(3) + ')', offset: t * .74 });
      }
      frames.push({ transform: 'translate(' + x1 + 'px,' + (y1 - 30) + 'px) scale(1)', offset: .87 });
      frames.push({ transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(1.15,.85)', offset: 1 });
      var ball = flying = document.createElement('span');
      ball.className = 'pf-flyball';
      ball.setAttribute('aria-hidden', 'true');
      document.body.appendChild(ball);
      var run = ball.animate(frames, { duration: 860, easing: 'linear', fill: 'forwards' });
      setTimeout(onLand, 630);
      run.onfinish = function () {
        var out = ball.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, delay: 120, fill: 'forwards' });
        out.onfinish = function () { ball.remove(); if (flying === ball) flying = null; };
      };
    }

    function pfPick(who, paddle) {
      pf.setAttribute('data-who', who);
      pf.querySelectorAll('.pf-paddle').forEach(function (p) { p.setAttribute('aria-pressed', String(p.dataset.who === who)); });
      pfMsg.textContent = pfSay[who];
      var rank = pfRank[who];
      var best = rank.length ? document.getElementById(rank[0]) : null;
      // shuffle: note where every card is, move the matches into the top row, then slide each card from old spot to new
      pfCards.forEach(function (card) { card._from = card.getBoundingClientRect(); card.classList.remove('is-best', 'is-boing'); });
      pfCards.filter(function (card) { return rank.indexOf(card.id) < 0; })
        .sort(function (x, y) { return x._order - y._order; })
        .forEach(function (card) { card._home.appendChild(card); card.classList.remove('is-fit'); });
      rank.forEach(function (id, i) { var card = document.getElementById(id); pfTopGrid.appendChild(card); card.classList.toggle('is-fit', i > 0); });
      pfTop.hidden = !rank.length;
      if (rank.length) pfTopFor.textContent = pfFor[who];
      pfGroups.forEach(function (g) { g.hidden = !g.querySelector('.pf-card'); });
      var landing = best ? best.querySelector('.pf-match').getBoundingClientRect() : null;
      var bestTop = best ? best.getBoundingClientRect().top : 0;
      if (!reduce && document.body.animate) {
        pfCards.forEach(function (card) {
          var to = card.getBoundingClientRect();
          var dx = card._from.left - to.left, dy = card._from.top - to.top;
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          var tilt = (card._order % 2 ? 1 : -1) * 4;
          card.classList.add('is-moving');
          var move = card.animate([
            { transform: 'translate(' + dx + 'px,' + dy + 'px)' },
            { transform: 'translate(' + (dx * .25) + 'px,' + (dy * .25) + 'px) rotate(' + tilt + 'deg)', offset: .55 },
            { transform: 'none' }
          ], { duration: 680, easing: 'cubic-bezier(.3,.7,.3,1)' });
          move.onfinish = function () { card.classList.remove('is-moving'); };
        });
      }
      var cols = pfCols[who];
      pf.querySelectorAll('.pf-compare [data-col]').forEach(function (cell) {
        var i = cols.indexOf(cell.dataset.col);
        cell.classList.toggle('col-fit', i > -1);
        cell.classList.toggle('col-best', i === 0);
      });
      replay(pfBuddy, 'is-hop');
      replay(pfBubble, 'is-pop');
      if (paddle) replay(paddle.querySelector('.pf-bat'), 'is-swing');
      if (!best) return;
      pfJump.href = '#' + best.id;
      pfJump.textContent = pfJumpTo[who];
      pfBubble.style.setProperty('--c', best.style.getPropertyValue('--c'));
      var from = paddle ? paddle.querySelector('.pf-bat-head') : pfBuddy;
      if (bestTop > 20 && bestTop < window.innerHeight - 140) {
        fly(from, landing, function () { best.classList.add('is-best'); replay(best, 'is-boing'); });
      } else {
        best.classList.add('is-best');
        fly(from, pfJump, function () { replay(pfJump, 'is-wiggle'); });
      }
    }
    pf.querySelectorAll('.pf-paddle').forEach(function (p) {
      p.addEventListener('click', function () { pfPick(p.dataset.who, p); });
    });
    document.getElementById('pf-reset').addEventListener('click', function () {
      pfPick('all', pf.querySelector('.pf-paddle[data-who="all"]'));
    });
    pfJump.addEventListener('click', function (e) {
      var card = document.getElementById(pfJump.getAttribute('href').slice(1));
      if (!card) return;
      e.preventDefault();
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { replay(card, 'is-boing'); }, reduce ? 0 : 600);
    });

    // The ball's eyes follow your pointer
    if (!reduce) {
      var eyeFrame = 0, lastEvent = null;
      window.addEventListener('pointermove', function (e) {
        lastEvent = e;
        if (eyeFrame) return;
        eyeFrame = requestAnimationFrame(function () {
          eyeFrame = 0;
          var r = pfBuddy.getBoundingClientRect();
          var dx = lastEvent.clientX - (r.left + r.width / 2), dy = lastEvent.clientY - (r.top + r.height / 2);
          var d = Math.sqrt(dx * dx + dy * dy) || 1, k = Math.min(1, d / 120) * 2.6;
          pfBuddy.style.setProperty('--px', (dx / d * k).toFixed(2) + 'px');
          pfBuddy.style.setProperty('--py', (dy / d * k).toFixed(2) + 'px');
        });
      });
    }

    // PONGO letters hop once when the finder scrolls into view (and again on hover)
    if (!reduce && 'IntersectionObserver' in window) {
      var hello = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          pf.classList.add('is-hello');
          setTimeout(function () { pf.classList.remove('is-hello'); }, 1200);
          hello.disconnect();
        });
      }, { threshold: .4 });
      hello.observe(pf.querySelector('.pf-head'));
    }


    initWaitlists(pf);
  }

  // Waitlists are Shopify customer forms. Shopify reloads the page after a signup with ?customer_posted=true,
  // and every customer form on the page then counts as posted, so remember which one was used.
  function initWaitlists(pf) {
    var KEY = 'pongo-waitlist';
    pf.querySelectorAll('[data-pf-waitlist]').forEach(function (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(KEY, form.getAttribute('data-pf-waitlist')); } catch (err) {}
      });
    });
    var used = null;
    try { used = sessionStorage.getItem(KEY); } catch (err) {}
    if (!used) {
      var m = location.hash.match(/^#pongo-waitlist-(\w+)/);
      if (m) used = m[1];
    }
    if (!used) return;
    var form = pf.querySelector('[data-pf-waitlist="' + used + '"]');
    if (!form) return;
    var error = form.querySelector('[data-pf-waitlist-error]');
    if (/customer_posted=true/.test(location.search) && !error) {
      var done = pf.querySelector('[data-pf-waitlist-done="' + used + '"]');
      if (done) { done.hidden = false; form.hidden = true; }
      try { sessionStorage.removeItem(KEY); } catch (err) {}
    } else if (error) {
      error.hidden = false;
    }
  }

  function initAll() { document.querySelectorAll('[data-pongo-finder]').forEach(initFinder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // theme editor: sections re-render without a page load
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pongo-finder]');
    if (el) initFinder(el);
  });
})();
